import React from "react";
import "./Header.css";

const Header = ({ isOfferPage }) => {
  isOfferPage = true;
  const logoSrc = isOfferPage
    ? "/assets/img/group318.png"
    : "/assets/img/group318.png";

  return (
    <header className="header-gold">
      <img src={logoSrc} alt="Digit Money Logo" className="logo-img" />
    </header>
  );
};

export default Header;
